import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  signal,
  untracked,
} from '@angular/core';
import { RvBadgeComponent } from '../rv-badge/rv-badge.component';

@Component({
  selector: 'status-badge',
  template: `
    <div [hidden]="!loading()" class="empty-badge"></div>
    <rv-badge
      [hidden]="loading()"
      [text]="text()"
      [color]="badgeColor()"
      [class.grow-from-50]="animating()"
    />
  `,
  styleUrls: ['./status-badge.component.scss'],
  imports: [RvBadgeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusBadgeComponent {
  status = input<string>('');
  animate = input<boolean>(false);

  protected text = computed(() => this.getStatusText(this.status()));
  loading = signal<boolean>(false);
  animating = signal<boolean>(false);

  badgeColor = computed<'green' | 'yellow' | 'gray'>(() => {
    const status = this.status();
    if (status === 'Published') return 'green';
    if (status === 'Pending Review') return 'yellow';
    return 'gray';
  });

  private isFirstChange = true;

  constructor() {
    effect(() => {
      // Register dependencies to track changes
      this.status();
      const shouldAnimate = this.animate();

      if (this.isFirstChange) {
        this.isFirstChange = false;
        return;
      }

      if (shouldAnimate) {
        untracked(() => {
          this.loading.set(true);
          setTimeout(() => {
            this.loading.set(false);
            this.animateBadge();
          }, 1550);
        });
      }
    });
  }

  private animateBadge() {
    this.animating.set(true);
    setTimeout(() => {
      this.animating.set(false);
    }, 150);
  }

  private getStatusText(status: string) {
    return status === 'Revised' ? 'Draft' : status;
  }
}
